import { Component, OnInit, OnChanges, Input, ChangeDetectionStrategy } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";

import { WebCallTopicService } from "@onsip/common/services/api/resources/webCallTopic/web-call-topic.service";
import { TopicFormService } from "../../services/topic-form.service";

import { targetDisplayValid, targetDisplayUnique } from "./target-display.validator";

import { GenericSimpleChange } from "@onsip/common/interfaces/generic-simple-change";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "onsip-target-display-form",
  templateUrl: "./target-display-form.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TargetDisplayFormComponent implements OnInit, OnChanges {
  @Input() initialValue: string | undefined;
  @Input() currentTarget: string | undefined;
  @Input() disabled = false;
  @Input() isAdding = false;

  formControl!: FormControl;

  constructor(
    private webCallTopicService: WebCallTopicService,
    private topicForm: TopicFormService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.formControl = new FormControl(this.initialValue ? this.initialValue : "", {
      updateOn: "change",
      validators: [
        Validators.minLength(2),
        targetDisplayValid(),
        targetDisplayUnique(this.webCallTopicService, this.currentTarget)
      ]
    });
    // Hack to prevent ExpressionChangedAfterItHasBeenCheckedError
    Promise.resolve().then(() => this.topicForm.addControl("targetDisplay", this.formControl));
  }

  ngOnChanges(changes: {
    disabled: GenericSimpleChange<boolean>;
    initialValue: GenericSimpleChange<string | undefined>;
  }) {
    if (this.formControl) {
      if (changes.disabled && changes.disabled.currentValue) {
        this.formControl.disable();
      } else {
        this.formControl.enable();
      }
      if (changes.initialValue && changes.initialValue.currentValue) {
        this.formControl.setValue(changes.initialValue.currentValue);
      }
    }
  }

  getErrors(): string {
    return this.formControl.hasError("minlength")
      ? this.translate.instant("ONSIP_I18N.TOPIC_NAME_MUST_BE_AT_LEAST_2_CHARACTERS")
      : this.formControl.hasError("targetDisplayValid")
      ? this.translate.instant(
          "ONSIP_I18N.TOPIC_NAMES_SHOULD_START_WITH_A_LETTER_AND_CANNOT_INCLUDE_SPECIAL_CHARACTERS"
        )
      : this.formControl.hasError("targetDisplayNotUnique")
      ? this.translate.instant("ONSIP_I18N.A_TOPIC_WITH_THAT_NAME_ALREADY_EXISTS")
      : "";
  }
}
